import React, { Component } from "react"
import { Grid, Col, Row, FormControl } from "react-bootstrap"
import { ExportToCsv } from "export-to-csv"
import ReactTable from "react-table-6"
import Moment from "react-moment"
import moment from "moment"
import Loader from "components/Loader/loader.jsx"
import Button from "components/CustomButton/CustomButton.jsx"

import "react-table-6/react-table.css"
import IconImage from "components/Icon/icon.jsx"
import { userService } from 'helpers/user.service.jsx';
const Config = require("config")

class PayoutsSearch extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      Payoutssdatalist: [],
      addressesdatalist: [],
      ref_id: "",
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.handleValidate = this.handleValidate.bind(this)
    //  console.log('this.props', this.props)
  }

  componentWillMount() {}

  getPayoutss() {
    this.setState({ loading: true })
    userService.getinfo().then((data)=>{
    var user = JSON.parse(data)
    var ref_id = this.state.ref_id
    var token = user.token
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-token": token,
        mid: user.data.merchant_id,
      },
      body: JSON.stringify({ ref_id }),
    }

    fetch(Config.API + "/api/payoutswithdrawsbyref/", requestOptions)
      .then(this.handleResponse)
      .then((withdrawdata) =>
        this.setState({ Payoutsdatalist: withdrawdata.data, loading: false })
      )
  })
  }

  handleResponse(response) {
    return response.text().then((text) => {
      const data = text && JSON.parse(text)

      if (!response.ok) {
        // const error = (data && data.message);
        return "error"
      } else {
        if (data.status == "error") {
          userService.logoutuser()
          return "error"
        }
      }

      return data
    })
  }

  handleChange(e) {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }

  handleValidate(e) {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }

  handleSubmit(e) {
    e.preventDefault()
    const { ref_id } = this.state
    if (ref_id != "") {
      this.getPayoutss()
    }
  }

  render() {
    const { ref_id } = this.state

    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id
      return row[id] !== undefined
        ? isNaN(row[id])
          ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
          : String(row[id]).startsWith(filter.value)
        : true
    }

    if (this.state.loading) return <Loader />
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col lg={12}>
              {" "}
              <h3 className="header">Payouts Search by Ref/ Invoice ID</h3>
            </Col>
            <Col lg={12}>
              <div className="card">
                <div className="content">
                  <div className="options">
                    <FormControl
                      type="text"
                      name="ref_id"
                      value={ref_id}
                      placeholder="Ref/ Invoice ID"
                      onBlur={this.handleValidate}
                      onChange={this.handleChange}
                    />
                    <Button
                      bsStyle="default"
                      onClick={() => this.getPayoutss()}>
                      Go
                    </Button>
                  </div>
                  <h2 className="header">Payout</h2>
                  <ReactTable
                    data={this.state.Payoutsdatalist}
                    filterable
                    defaultFilterMethod={(filter, row) =>
                      filterCaseInsensitive(filter, row)
                    }
                    columns={[
                      {
                        Header: "Coin",

                        accessor: "coin",
                        Cell: (row) => {
                          if (row.value) {
                            return (
                              <div alt={row.value}>
                                {" "}
                                <IconImage coin={row.value} />
                                {row.value}
                              </div>
                            )
                          } else {
                            return <div></div>
                          }
                        },
                      },
                      {
                        Header: "Ref Id",
                        accessor: "ref_id",
                      },
                      {
                        Header: "Id",
                        accessor: "id",
                      },
                      {
                        Header: "Date",
                        accessor: "date_time",
                        id: "date_time",
                        Cell: (props) => {
                          return (
                            <Moment format="YYYY-MM-D H:mm:ss">
                              {props.value}
                            </Moment>
                          )
                        },
                      },

                      {
                        filterable: false,
                        Header: "Transaction Type",
                        accessor: "transaction_type",
                      },
                      {
                        Header: "Amount",
                        accessor: "amount",
                      },
                      {
                        Header: "TX Fee",

                        accessor: "fnetwork_fee",
                      },
                      {
                        Header: "$ Price",
                        id: "price",
                        accessor: (d) => {
                          return d.price == null ? 0 : d.price
                        },
                        Cell: (props) => (
                          <div>
                            {props.original.coin == "SHIB"
                              ? props.value.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 6,
                                })
                              : props.value.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 2,
                                })}
                          </div>
                        ),
                      },
                      {
                        id: "amount_in_fiat",
                        Header: "$ Amount",

                        accessor: (d) => {
                          return d.fee_in_fiat == null ? 0 : d.amount_in_fiat
                        },
                        Cell: (props) => (
                          <div>
                            {props.original.coin == "SHIB"
                              ? props.value.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 6,
                                })
                              : props.value.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 2,
                                })}
                          </div>
                        ),
                      },
                      {
                        id: "fee_in_fiat",
                        Header: "$ TX Fee",

                        accessor: (d) => {
                          return d.fee_in_fiat == null ? 0 : d.fee_in_fiat
                        },
                        Cell: (props) => (
                          <div>
                            {props.original.coin == "SHIB"
                              ? props.value.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 6,
                                })
                              : props.value.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 2,
                                })}
                          </div>
                        ),
                      },
                      {
                        Header: "Transaction Id",

                        accessor: "txid",
                      },

                      {
                        Header: "Address",

                        accessor: "address",
                      },
                      {
                        Header: "Tag",

                        accessor: "tag",
                      },
                      {
                        Header: "Status",

                        accessor: "status",
                      },
                      {
                        id: "balance",
                        Header: "Balance",

                        accessor: (d) => {
                          return <d className="balance"></d> == null
                            ? 0
                            : d.balance
                        },
                        Cell: (props) =>
                          props.value.toLocaleString(navigator.language, {
                            minimumFractionDigits: 8,
                          }),
                      },
                      {
                        id: "balance_in_fiat",
                        Header: "Balance in Fiat",

                        accessor: (d) => {
                          return d.balance_in_fiat == null
                            ? 0
                            : d.balance_in_fiat
                        },
                        Cell: (props) => (
                          <div>
                            {props.original.coin == "SHIB"
                              ? props.value.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 6,
                                })
                              : props.value.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 2,
                                })}
                          </div>
                        ),
                      },
                    ]}
                    noDataText="No Payouts Found"
                    className="-striped -highlight"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default PayoutsSearch
